var _path, _rect, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedeemInWeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 51,
    viewBox: "0 0 70 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.22892 4.13004C-8.64551 16.2749 5.28352 33.0648 14.2323 39.9417C26.788 49.5904 55.8227 58.8253 67.8943 39.9417C81.3014 18.969 27.072 -11.051 7.22892 4.13004Z",
    fill: "#F4F5F7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27.5947,
    y: 13.0938,
    width: 24.4054,
    height: 17.3108,
    rx: 2.83784,
    fill: "#F1BD6C"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.0273,
    y: 18.4857,
    width: 17.3108,
    height: 11.9189,
    rx: 2.55405,
    fill: "#E8EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.48 26.2001C29.3754 25.4318 28.5178 24.3129 28.1177 22.9703C27.9733 22.4809 28.0681 21.9617 28.3789 21.545C28.7857 20.9971 29.5044 20.7469 30.1493 20.9398C31.4919 21.3388 32.6108 22.1965 33.3791 23.301V18.4838H20.7023C19.1822 18.4838 17.9465 19.7206 17.9465 21.2396V26.2001H30.48Z",
    fill: "#83A9FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5978 22.205C38.4909 22.0617 38.3299 21.9757 38.1657 21.9757C38.1194 21.9757 38.072 21.9834 38.0246 21.9967C36.1275 22.561 34.7496 24.2289 34.5159 26.1656C36.4527 25.932 38.1205 24.5551 38.6838 22.6569C38.7477 22.4486 38.6573 22.2844 38.5978 22.205Z",
    fill: "#83A9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4812 23.301C35.2495 22.1965 36.3684 21.3388 37.711 20.9387C38.3559 20.7458 39.0735 20.9971 39.4813 21.5439C39.7922 21.9606 39.887 22.4809 39.7415 22.9692C39.3425 24.3107 38.4848 25.4296 37.3792 26.199H44.4021V21.2396C44.4021 19.7206 43.1664 18.4838 41.6463 18.4838H34.4812V23.301Z",
    fill: "#83A9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8366 21.9967C29.7892 21.9834 29.7418 21.9757 29.6955 21.9757C29.5324 21.9757 29.3703 22.0617 29.2634 22.205C29.2039 22.2844 29.1135 22.4486 29.1763 22.6569C29.7407 24.554 31.4074 25.9309 33.3442 26.1656C33.1116 24.2289 31.7348 22.561 29.8366 21.9967Z",
    fill: "#83A9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3788 28.0815L31.0133 30.4471C30.9052 30.5551 30.7641 30.6092 30.623 30.6092C30.4819 30.6092 30.3408 30.5551 30.2328 30.4482C30.0179 30.2333 30.0179 29.8838 30.2328 29.6689L32.5995 27.3022H17.9463V33.365C17.9463 34.884 19.182 36.1208 20.7021 36.1208H33.3788V28.0815ZM21.8044 29.5068H26.2137C26.518 29.5068 26.7649 29.7538 26.7649 30.058C26.7649 30.3622 26.518 30.6092 26.2137 30.6092H21.8044C21.5002 30.6092 21.2533 30.3622 21.2533 30.058C21.2533 29.7538 21.5002 29.5068 21.8044 29.5068ZM29.5207 32.8138H21.8044C21.5002 32.8138 21.2533 32.5669 21.2533 32.2626C21.2533 31.9584 21.5002 31.7115 21.8044 31.7115H29.5207C29.8249 31.7115 30.0719 31.9584 30.0719 32.2626C30.0719 32.5669 29.8249 32.8138 29.5207 32.8138Z",
    fill: "#83A9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2603 27.3022L37.6259 29.6678C37.8408 29.8827 37.8408 30.2322 37.6259 30.4471C37.519 30.5551 37.3779 30.6092 37.2368 30.6092C37.0957 30.6092 36.9546 30.5551 36.8465 30.4482L34.481 28.0815V36.1208H41.6461C43.1662 36.1208 44.4019 34.884 44.4019 33.365V27.3022H35.2603Z",
    fill: "#83A9FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1912 9.965L39.5914 9.44783C39.0637 7.99208 41.4139 7.46724 40.8861 6L42.4859 6.51718C43.0137 7.98442 40.6635 8.50926 41.1912 9.965Z",
    fill: "#FCDF98"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6193 10.0066L22.7996 11.3819C21.2368 11.6021 21.1445 9.34913 19.5748 9.56211L20.3901 8.18811C21.9598 7.97513 22.0521 10.2281 23.6193 10.0066Z",
    fill: "#84C8B1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4403 43.8574L34.2009 42.8439C34.2136 41.2657 36.4555 41.5065 36.4763 39.9226L37.7151 40.9316C37.6943 42.5155 35.4524 42.2747 35.4403 43.8574Z",
    fill: "#84C8B1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8634 27.7625L10.4455 26.3706C11.2228 25.1128 12.7536 26.3554 13.5396 25.0967L13.9592 26.4847C13.1732 27.7433 11.6424 26.5008 10.8634 27.7625Z",
    fill: "#F4AE72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedeemInWeb);
export default __webpack_public_path__ + "static/media/redeem-in-web.0badcb33724834a97b5c1f72b31cc8f0.svg";
export { ForwardRef as ReactComponent };